module.exports = __webpack_public_path__ + "5387cce7d97fd42e13b2e9589939467b.png";